import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { User, UserRequest } from '../models/user.model';
import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService{
  constructor(private http: HttpClient) {
    super(http);
  }

  getUsers(params?: string): Observable<any> {
    let httpParams = new HttpParams();
    if (!!params) {
      httpParams = httpParams.set('value', params);
    }

    return super.get<any[]>(
      `User/Find`,
     httpParams)
    .pipe(
      map((response: any[]) => response.map(user => <User>user))
    );
  }

  getOperators(): Observable<User[]> {
    return super.get<User[]>(
      `User/GetOperators`)
    .pipe(
      map((response: User[]) => response.map(user => <User>user))
    );
  }

  createUser(user: UserRequest): Observable<User> {
    return super.post<User>(
      `User`,
      user
    );
  }

  editUser(user: UserRequest): Observable<User> {
    return super
      .put<User>(
        `User/${user.id}`,
        user
      );
  }

  getByHash(userHash?: string): Observable<User> {
    return super.get<User>(
      `User/GetByHash/${userHash}`);
  }

  enableUser(userId?: string): Observable<any> {
    return super.patch(
      `User/Enable/${userId}`, {});
  }

  disableUser(userId?: string): Observable<any> {
    return super.patch(
      `User/Disable/${userId}`, {});
  }

  deleteUser(userId?: string): Observable<any> {
    return super.deleteMethod(
      `User/${userId}`);
  }
}
